import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { mockSupabase } from './mock-supabase';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

const useMock = !url || !anon;

if (useMock) {
  // Demo / public-launch mode: everything runs in the browser via localStorage.
  // Set VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY in .env.local to switch to
  // a real cloud Supabase project.
  console.warn('[nako] Running in LOCAL DEMO mode — data lives in your browser only.');
}

export const IS_LOCAL_DEMO = useMock;

export const supabase: SupabaseClient = useMock
  ? (mockSupabase as unknown as SupabaseClient)
  : createClient(url, anon, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
